export default __webpack_public_path__ + "static/media/hand.b513d709.webp";